import { Header } from './Header';
import { Footer } from './Footer';
import { PromoBanner } from './PromoBanner';
import { NewsletterPopup } from './NewsletterPopup';
import { Toaster } from '../ui/sonner';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col paper-texture">
      <PromoBanner />
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <NewsletterPopup />
      <Toaster position="top-right" richColors />
    </div>
  );
};
